/**
 * @fileoverview Styled input control with consistent border/focus styles.
 *
 * @purpose Shared text input used across forms and admin controls.
 * @usage Imported by admin setting forms, Rag Manager upload fields, etc.
 * @ownership Shared UI components (core)
 * @dependencies
 * - react
 * - @/core/lib/utils (cn helper)
 * @restrictions
 * - DO NOT add business logic; keep this component purely presentational.
 */
import * as React from "react"

import { cn } from '../../lib/utils';

export type InputProps = {} & React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border korvo-bg-input-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        style={{
          color: 'var(--input-foreground)',
          borderColor: 'var(--input-border)',
        }}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }